import GenericField from './GenericFieldComponent'
export default GenericField
